;( function( $, undefined )
{

    $.fn.SiteCatalystForum = function( siteCat )
    {
        $('.pdc6-button-blue.add-button.left-button').on( 'click', function()
        {
            siteCat.track( 'Intent to create a new thread', {
                type   : siteCat.eventType.other,
                vars   : {
                    prop49 : 'button:intent to create a new thread:null:' + siteCat.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( '#topic-select-topics' ).find( 'a' ).on( 'click', function()
        {
            var label    = $( this ).find( '.topic' ).data( 'image-name' ).replace( /\_$/, '' ).toLowerCase(),
                position = $( this ).parent().index() + 1;

            siteCat.track( 'Hero: topic clicked', {
                type   : siteCat.eventType.other,
                vars   : {
                    prop49 : 'button:' + label + ':pos-' + position + ':' + siteCat.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );


    };

} )( jQuery );
